// src/Capacitor/logger/initLogger.ts
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { logger } from '@/capacitor/logger/simplelogger';

// 初始化日志系统
// - hookConsole() 已在 logger-boot 中最早执行（避免重复 hook）
// - 注册 beforeunload、App.pause 以及 App.resume 等生命周期回调以保证日志刷盘
export async function initLogger(): Promise<void> {
  try {
    // 启动时写入一条日志（
    console.log('应用启动');

    // 窗口卸载时强制写盘（网页/桌面场景）
    window.addEventListener('beforeunload', async () => {
      console.warn('退出应用');
      try { await logger.flushAll(); } catch (e) { console.error('flushAll() 失败:', e); }
    });

    // 在原生平台使用 Capacitor App 事件
    if (Capacitor.isNativePlatform()) {
      // pause -> 刷盘
      App.addListener('pause', async () => {
        console.warn('App pause - 刷新日志缓冲区');
        try { await logger.flushAll(); } catch (e) { console.error('flushAll() 失败:', e); }
      });
      // resume -> 可做额外处理（这里保持简单日志）
      App.addListener('resume', () => {
        console.log('App resume');
      });
    } else {
      // 非原生平台备用：visibilitychange
      window.addEventListener('visibilitychange', async () => {
        if (document.hidden) {
          console.warn('visibilitychange:hidden - 刷新日志缓冲区');
          try { await logger.flushAll(); } catch (e) { console.error('flushAll() 失败:', e); }
        }
      });
    }
  } catch (error) {
    console.error('无法初始化日志系统:', error);
  }
}
